import { PanelLeft } from 'lucide-react'
import { Breadcrumbs } from '../Breadcrumbs/Breadcrumbs'
import { UserMenu } from '../UserMenu/UserMenu'
import type { AppTopbarProps } from './AppTopbar.types'
import './AppTopbar.css'

export function AppTopbar({ onToggleSidebar }: AppTopbarProps) {
  return (
    <header className="app-topbar">
      <button
        type="button"
        className="app-topbar__toggle"
        aria-controls="app-sidebar"
        aria-label="Toggle navigation"
        onClick={onToggleSidebar}
      >
        <PanelLeft size={20} strokeWidth={1.75} aria-hidden="true" />
      </button>
      <Breadcrumbs />
      <div className="app-topbar__end">
        <UserMenu />
      </div>
    </header>
  )
}
